import { Component } from "react"

/* Components */
import { Input } from "../../components"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { censorCreate, censorUpdate } from "../../api/Message"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { CloseIcon, ShieldIcon, InfoIcon, BookIcon } from "./MessageIcons"

/* Sweet alert */
import Swal from "../../helpers/alert"


/* THE LONGEST WORD THAT STILL MEANS SOMETHING — THE VERY SAME NUMBER THE CONTROLLER KEEPS */
const MAX_LENGTH = 60

/* EMPTY FORM STATE */
const EMPTY = {
    id: null,
    word: "",
    type: "root",
    comment: "",
    waiting: false,
}


/* Widget Censor Form — одно слово словаря: добавить новое или изменить существующее */
class CensorForm extends Component {

    constructor() {
        super()
        this.state = { visible: false, ...EMPTY }
    }

    /* Open Action — a row opens the form for a change, an empty call opens it for a new word */
    open = (item = null) => {

        /* Check Item */
        if (!item) {
            this.setState({ visible: true, ...EMPTY })
            return
        }

        this.setState({
            visible: true,
            ...EMPTY,
            id: item.id,
            word: item.word ? item.word : "",
            type: item.type === "exact" ? "exact" : "root",
            comment: item.comment ? item.comment : "",
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, ...EMPTY })
    }

    /* Read The Error Message Of A Response */
    message = (response) => {

        if (response && response.data && response.data.message) {
            return response.data.message
        }

        if (response && response.status === 498) {
            return t("swal.invalidKey")
        }

        if (response && (response.status === 401 || response.status === 403)) {
            return t("swal.noAccess")
        }

        return t("swal.generic")
    }

    /* Save Action — the very same form writes a new word and changes an old one */
    save = () => {

        /* Fields */
        const { id, word, type, comment } = this.state
        const { reload } = this.props

        /* Word */
        const value = word.trim()

        /* Check Word */
        if (value === "") {
            Swal.fire(utils.notification(t("censor.error.empty"), "error"))
            return
        }

        /* Check Length */
        if (value.length > MAX_LENGTH) {
            Swal.fire(utils.notification(t("censor.error.long"), "error"))
            return
        }

        /* Start Waiting */
        this.setState({ waiting: true })

        /* Request */
        const request = id
            ? censorUpdate({ id, word: value, type, comment })
            : censorCreate({ word: value, type, comment })

        /* Send to REST API */
        request.then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(id ? t("censor.updated") : t("censor.created"), "success"))
                reload()
                this.close()
            }
            else {
                Swal.fire(utils.notification(this.message(response), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })

    }

    /* Draw Word */
    _word = () => {

        /* Fields */
        const { word } = this.state

        return (
            <div className="msg--section">

                <div className="msg--section-head">
                    <div className="msg--section-title">
                        <BookIcon />
                        {t("censor.word")}
                    </div>
                </div>

                <Input
                    label={t("censor.wordLabel")}
                    value={word}
                    onChange={(event) => this.setState({ word: event.target.value })}
                    maxLength={MAX_LENGTH}
                />

                <div className="msg--hint">
                    <InfoIcon size={14} />
                    <span>{t("censor.wordHint")}</span>
                </div>

            </div>
        )
    }

    /* Draw Type — a root covers every form of a word at once, an exact word touches nothing around it */
    _type = () => {

        /* Fields */
        const { type } = this.state

        return (
            <div className="msg--section">

                <div className="msg--section-head">
                    <div className="msg--section-title">
                        <ShieldIcon />
                        {t("censor.type")}
                    </div>
                </div>

                <div className="msg--chips">

                    <div onClick={() => this.setState({ type: "root" })} className={`msg--chip ${type === "root" ? "active" : ""}`}>
                        {t("censor.type.root")}
                    </div>

                    <div onClick={() => this.setState({ type: "exact" })} className={`msg--chip ${type === "exact" ? "active" : ""}`}>
                        {t("censor.type.exact")}
                    </div>

                </div>

                <div className="msg--hint">
                    <InfoIcon size={14} />
                    <span>{type === "root" ? t("censor.type.rootHint") : t("censor.type.exactHint")}</span>
                </div>

            </div>
        )
    }

    /* Draw Comment — why the word is in the dictionary at all */
    _comment = () => {

        /* Fields */
        const { comment } = this.state

        return (
            <div className="msg--section">
                <Input
                    label={t("censor.comment")}
                    value={comment}
                    onChange={(event) => this.setState({ comment: event.target.value })}
                    maxLength={190}
                />
            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, waiting, id } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="msg--modal"
                overlayClassName="msg--overlay"
                closeTimeoutMS={200}
            >

                <div className="msg--modal-header">

                    <div className="msg--modal-icon">
                        <ShieldIcon size={18} />
                    </div>

                    <div className="msg--modal-head-text">
                        <h2>{id ? t("censor.editTitle") : t("censor.createTitle")}</h2>
                        <p>{t("censor.formSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="msg--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="msg--modal-body">

                    {/* Draw Word */}
                    {this._word()}

                    {/* Draw Type */}
                    {this._type()}

                    {/* Draw Comment */}
                    {this._comment()}

                </div>

                <div className="msg--modal-footer">

                    <div onClick={() => this.close()} className="msg--button ghost">{t("common.cancel")}</div>

                    {waiting
                        ? <div className="msg--button primary"><div className="msg--loading small" /></div>
                        : <div onClick={() => this.save()} className="msg--button primary">{id ? t("censor.save") : t("censor.add")}</div>
                    }

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(CensorForm)
